import apiClient from './apiClient';

export const licenseRequestService = {
  // Upload and parse cluster.request file
  uploadClusterRequest: async (formData) => {
    const response = await fetch(`${process.env.VITE_API_URL || 'http://localhost:3001'}/api/license-requests/upload`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: formData
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error?.message || 'Upload failed');
    }

    return response.json();
  },

  // Create license request from parsed data
  createLicenseRequest: async (requestData) => {
    const res = await apiClient.post('/license-requests/create', requestData);
    return res;
  },

  // Legacy create method for backward compatibility
  create: async ({ nodes, sockets, type, productId, notes }) => {
    const res = await apiClient.post('/license-requests', { nodes, sockets, type, productId, notes });
    return res.request || res;
  },

  // Get user's own requests
  myRequests: async () => {
    const res = await apiClient.get('/license-requests/mine');
    return res.requests || res;
  },

  // Get single request detail (for users)
  getMyRequest: async (id) => {
    const res = await apiClient.get(`/license-requests/mine/${id}`);
    return res.request || res;
  },

  // Admin: List all requests
  adminList: async () => {
    const res = await apiClient.get('/license-requests');
    return res.requests || res;
  },

  // Admin: Get detailed request info
  adminGetRequest: async (id) => {
    const res = await apiClient.get(`/license-requests/${id}`);
    return res.request || res;
  },

  // Admin: Approve request with license details
  approve: async (id, licenseDetails = {}, responseNotes = '') => {
    const res = await apiClient.post(`/license-requests/${id}/approve`, { 
      licenseDetails,
      responseNotes 
    });
    return res;
  },

  // Admin: Reject request
  reject: async (id, responseNotes = '') => {
    const res = await apiClient.post(`/license-requests/${id}/reject`, { responseNotes });
    return res;
  },
};

export default licenseRequestService;
